const COMMERCE_CURRENCY = 'COMMERCE_CURRENCY';
const DEFAULT_COMMERCE_CURRENCY_CODE = 'GBP';
const COMMERCE_ORDER = 'COMMERCE_BASKET';
const COMMERCE_FILTERED_PARAMS = 'COMMERCE_FILTERED_PARAMS';
export {
    COMMERCE_CURRENCY,
    DEFAULT_COMMERCE_CURRENCY_CODE,
    COMMERCE_ORDER,
    COMMERCE_FILTERED_PARAMS,
}